<template>
  <demandActionButton
    :disabled="!isValidSeatCount"
    page="2"
    button1-string="戻る"
    :button1-action="backToPreviousPage"
    button2-string="決済方法 ＞"
    :button2-action="gotoBooking3"
  />
</template>

<script>
import { useStore } from "vuex";
import { useRouter } from "vue-router";

export default {
  name: "TheDemandActionButton2",
  props: {
    seatCount: {
      type: Object,
      require: true,
    },
    pickuptime: {
      type: String,
      require: true,
    },
    isValidSeatCount: {
      typr: Boolean,
      require: true,
    },
  },
  setup(props) {
    const store = useStore();
    const router = useRouter();

    const gotoBooking3 = async () => {
      await store.commit("demand/setSeatCount", props.seatCount);
      await store.commit("demand/setPickUpTime", props.pickuptime);

      router.push({
        name: "DemandEbusBooking3",
      });
    };

    return {
      gotoBooking3,
    };
  },
};
</script>
